import { AssistantResponseTokenV2, EqlQueryType } from 'generated/graphql';

export const getAssistantResponseEqlType = (
  assistantResponseTokenV2List: AssistantResponseTokenV2[],
) => {
  const assistantResponseEqlToken = assistantResponseTokenV2List.find(
    (token) => token.eql?.eql,
  )?.eql;

  if (
    assistantResponseEqlToken?.eql?.properties.type === EqlQueryType.Aggregates
  ) {
    return 'quantify';
  }

  if (
    assistantResponseEqlToken?.eql?.properties.type === EqlQueryType.Records
  ) {
    return 'summary';
  }

  return null;
};
